(function () {
    'use strict';

    angular
        .module('garnaCabinet')
        .factory('AuthService', AuthService);

    AuthService.$inject = ['localStorageService'];

    /* @ngInject */
    function AuthService(localStorageService) {

        var service = {
            isAuthenticated: isAuthenticated,
            getUserId: getTokenSub
        };

        return service;

        function isAuthenticated() {
            var token = localStorageService.get('token');
            // A token is present
            if (token) {
                // Token with a valid JWT format XXX.YYY.ZZZ
                if (token.split('.').length === 3) {
                    // Could be a valid JWT or an access token with the same format
                    try {
                        var base64Url = token.split('.')[1];
                        var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
                        var exp = JSON.parse(window.atob(base64)).exp;
                        // JWT with an optonal expiration claims
                        if (exp) {
                            var isExpired = Math.round(new Date().getTime() / 1000) >= exp;
                            if (isExpired) {
                                // FAIL: Expired token
                                return false;
                            } else {
                                // PASS: Non-expired token
                                return true;
                            }
                        }
                    } catch (e) {
                        // PASS: Non-JWT token that looks like JWT
                        return false;//true;
                    }
                }
                // PASS: All other tokens
                return false;//true;
            }
            // FAIL: No token at all
            return false;
        }

        function getTokenSub() {
            const tokenPayload = getTokenPayload();
            if (tokenPayload && tokenPayload.sub) {
                return tokenPayload.sub;
            }
            return null;
        }

        function getTokenPayload() {
            var token = localStorageService.get('token');

            if (token && token.split('.').length === 3) {
                try {
                    var base64Url = token.split('.')[1];
                    var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
                    return JSON.parse(decodeURIComponent(encodeURIComponent(window.atob(base64))));
                } catch (e) {
                    return undefined;
                }
            }
        }
    }

})();

